import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EgonRoutesListStateType, EgonRouteType } from 'src/types/egonRoute';

const initialState: EgonRoutesListStateType = {
    data: null,
    loading: false,
    error: false,
};

export const egonRoutesListSlice = createSlice({
    name: 'egonRoutesList',
    initialState,
    reducers: {
        getEgonRoutesListFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getEgonRoutesListFetchSuccess: (state, action: PayloadAction<EgonRouteType[]>) => {
            state.data = action.payload;
            state.loading = false;
        },
        getEgonRoutesListFetchFailure: (state) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const { getEgonRoutesListFetch, getEgonRoutesListFetchSuccess, getEgonRoutesListFetchFailure } =
    egonRoutesListSlice.actions;

export default egonRoutesListSlice.reducer;
